import { Injectable } from '@angular/core';
import { OrderDownloadDtoService } from '@shared/services/file-download/order-download-dto.service';
import {
  DownloadFileTypes,
  SeperatorString,
} from '@shared/constants/order-download-file';
import { FileHandlerBaseService } from '../file-handler/file-handler-base.service';
import { ToastService } from '../toast/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { SentenceCasePipe } from '@shared/pipes/sentence-case.pipe';
import { LoadingSpinnerService } from '../loading-spinner/loading-spinner.service';
import { OrderInsightsDownloadDtoService } from './order-insights-download-dto.service';
import { DownloadOrderInsightsEvent } from '@order/models/download-orders-event';
import { PlatformService } from '@panamax/app-state';
import {
  CONTENT_TYPE_CSV,
  CONTENT_TYPE_CSV_ANDROID,
} from '@shared/constants/files';

@Injectable({
  providedIn: 'root',
})
export class OrderInsightsDownloadService extends FileHandlerBaseService {
  constructor(
    toastService: ToastService,
    public translateService: TranslateService,
    public platform: Platform,
    public platformService: PlatformService,
    public datePipe: DatePipe,
    public sentenceCasePipe: SentenceCasePipe,
    public loadingSpinnerService: LoadingSpinnerService,
  ) {
    super(
      toastService,
      translateService,
      platform,
      datePipe,
      sentenceCasePipe,
      loadingSpinnerService,
    );
  }

  downloadOrderInsightsFile(
    downloadOrderInsightsInfo: DownloadOrderInsightsEvent,
  ) {
    let fileContents: string;

    let separatedColumns;
    separatedColumns = OrderInsightsDownloadDtoService.createMultipleSeparatedColumnsForOrderInsights(
      downloadOrderInsightsInfo,
    );
    let numberOfRows = separatedColumns[0].columnValues.length;
    fileContents = OrderDownloadDtoService.stringifySeparatedValues(
      separatedColumns,
      numberOfRows,
      SeperatorString.comma,
    );

    const contentType = this.platform.is('android')
      ? CONTENT_TYPE_CSV_ANDROID
      : CONTENT_TYPE_CSV;

    const blob: Blob = new Blob([fileContents], {
      type: contentType,
    });
    return this.downloadFile(
      blob,
      downloadOrderInsightsInfo.fileName,
      contentType,
      this.platform.is('android'),
    );
  }
}
